import React from 'react';
import PropTypes from 'prop-types';
import NukaCarousel from 'nuka-carousel';

const propTypes = {
  slideIndex: PropTypes.number.isRequired,
  afterSlide: PropTypes.func.isRequired,
  slidesToShow: PropTypes.number,
  cellSpacing: PropTypes.number,
  children: PropTypes.node,
};

const Carousel = ({
  slideIndex,
  afterSlide,
  slidesToShow,
  cellSpacing,
  children,
}) => {
  return (
    <NukaCarousel
      slideIndex={slideIndex}
      afterSlide={afterSlide}
      slidesToShow={slidesToShow}
      cellSpacing={cellSpacing}
      heightMode="max"
      withoutControls
    >
      {children}
    </NukaCarousel>
  );
};

Carousel.propTypes = propTypes;

export default Carousel;
